// In-memory holding pen for policy files picked during the onboarding
// wizard.
//
// Why this exists: the wizard used to stash PDFs as base64 dataURLs in
// localStorage — but localStorage has a ~5 MB quota, so any realistic
// policy PDF silently blew the save and the document content vanished
// while the UI said "uploaded". Files now live here (real File objects,
// no quota) until the account exists, at which point CMCApp's backfill
// uploads them to blob storage and stamps blobPaths on school.policies.
//
// Scope: module memory — survives SPA navigation (wizard → login →
// dashboard is one session) but not a full page reload. As a fallback
// for reloads, small files (< ~1.5 MB) are still mirrored to
// localStorage by the wizard; large ones rely on this store.

const pending = new Map<string, File>();

export function holdPolicyFile(fileName: string, file: File): void {
  pending.set(fileName, file);
}

export function takePolicyFile(fileName: string): File | undefined {
  return pending.get(fileName);
}

export function clearPolicyFiles(): void {
  pending.clear();
}
